var map = {
	"./atlante-layer-manager/state/reducer": [
		31992,
		1992
	],
	"./custom-page/state/reducer": [
		88704,
		8704
	],
	"./dashboard/state/reducer": [
		49144,
		9144
	],
	"./news/state/reducer": [
		51312,
		1312
	],
	"./optimized-data-retriever/state/reducer": [
		42212,
		2212
	],
	"./view-widgets/state/reducer": [
		25764,
		5764
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 45396;
module.exports = webpackAsyncContext;